import { useMutation } from '@apollo/client';
import { updateCoverageHours } from 'graphql-queries';
import { CoverageHoursDayOfWeek } from './useCoverageHours';

export class CoverageHoursUpdateError extends Error {
  constructor(message: string, options?: { cause?: unknown }) {
    super(message, options);
    this.name = 'CoverageHoursUpdateError';
  }
}

export type UpdateCoverageHoursBlock = {
  daysOfWeek: CoverageHoursDayOfWeek[];
  startMinute: number;
  endMinute: number;
};

export type UpdateCoverageHoursTeam = {
  teamId: string;
  blocks: UpdateCoverageHoursBlock[];
};

export type UpdateCoverageHoursParams = {
  channelId: string;
  routingId: string;
  timezone: string;
  teams: UpdateCoverageHoursTeam[];
};

export type UseUpdateCoverageHoursResult = {
  updateCoverageHours: (params: UpdateCoverageHoursParams) => Promise<void>;
  loading: boolean;
};

export function useUpdateCoverageHours(): UseUpdateCoverageHoursResult {
  const [executeUpdate, { loading }] = useMutation(updateCoverageHours);

  const updateRouting = async (params: UpdateCoverageHoursParams) => {
    try {
      await executeUpdate({ variables: { input: params } });
    } catch (cause) {
      throw new CoverageHoursUpdateError('Could not update coverage hours', {
        cause,
      });
    }
  };

  return { updateCoverageHours: updateRouting, loading };
}
